import { Editor } from "@monaco-editor/react";
import { Card } from "antd";

const TranslationEditor = ({
  height = "50vh",
  translations,
  onUpdate,
  loading = false,
}) => {
  return (
    <Card loading={loading}>
      <Editor
        height={height}
        defaultLanguage="json"
        onChange={onUpdate}
        defaultValue={JSON.stringify(translations, null, 2)}
      />
    </Card>
  );
};

export default TranslationEditor;
